module.exports = __webpack_public_path__ + "static/media/val_skjold.a1cee358.png";